var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "article",
    { attrs: { id: _vm.documentId } },
    [
      _c("h3", { staticClass: "color_title" }, [
        _vm._v(_vm._s(_vm.title) + " 全" + _vm._s(_vm.colorList.length) + "色")
      ]),
      _vm._v(" "),
      [
        _c("div", { staticClass: "colorPallet" }, [
          _c("div", [
            _c("div", [
              _c("img", { attrs: { src: _vm.color.imgB } }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "enlargement",
                  on: {
                    click: function($event) {
                      _vm.previewColor(_vm.color.imgB)
                    }
                  }
                },
                [
                  _c("img", {
                    attrs: { src: _vm.getImage("common/icon_enlargement.svg") }
                  })
                ]
              )
            ]),
            _vm._v(" "),
            _vm.colorList.length > 0
              ? _c("div", { staticClass: "color_name" }, [
                  _vm.isSelectedColor
                    ? _c("div", [_vm._v(_vm._s(_vm.color.name))])
                    : _c("div", [_vm._v("カラーが選択されていません。")])
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "color_list" },
            _vm._l(_vm.colorList, function(color, index) {
              return _c(
                "figure",
                {
                  key: _vm.documentId + "-" + index,
                  attrs: { value: color.id }
                },
                [
                  _c("img", {
                    class: { selected: _vm.hasSelectId(color.id) },
                    attrs: { src: color.img },
                    on: {
                      click: function($event) {
                        _vm.$emit("selectColor", color)
                      }
                    }
                  })
                ]
              )
            })
          ),
          _vm._v(" "),
          _c("div", { staticClass: "color_list_sp" }, [
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.selColor,
                    expression: "selColor"
                  }
                ],
                on: {
                  change: [
                    function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.selColor = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    },
                    function($event) {
                      _vm.$emit("selectColor", _vm.selColor)
                    }
                  ]
                }
              },
              _vm._l(_vm.colorList, function(color, index) {
                return _c(
                  "option",
                  {
                    key: _vm.documentId + "-" + index,
                    domProps: { value: color }
                  },
                  [_vm._v(_vm._s(color.name))]
                )
              })
            )
          ])
        ])
      ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-36f5c534", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36f5c534","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/js/hakotan/components/top/input/color/DcColorPallet.vue
// module id = null
// module chunks = 